import { network } from 'services/network';

export const getValidationTypeDrillDown = (params) => {
    return network.post('api/bo/getValidationTypeDrillDown', params).then((response) => {
        return response.data;
    });
};
